import React, { useState } from 'react';
import { Notification } from "rbx";
import { Redirect, Link } from "react-router-dom";
import UserService from '../../../services/user';
import { unMask } from '../../../commons/masks';
import Controls from '../../components/Controls/Controls';
import useForm from '../../components/useForm';

function LoginForm() {
  const [redirectTo, setRedirectTo] = useState(false);

  const {
    values,
    status,
    setStatus,
    stateButton,
    setStateButton,
    handleInputChange
  } = useForm( {cpf_cnpj: '', password: ''} );

  if(redirectTo || sessionStorage.getItem('user'))
    return <Redirect to={{pathname: "/dashbord"}}/>

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStateButton("loading");
    try {
      const authorized = await UserService.login({...values, cpf_cnpj: unMask(values.cpf_cnpj)});
      if (authorized)
        setRedirectTo(true)
      else
        setStatus(['danger', 'Acesso restrito a Administradores.'])
    } catch(e) {
      setStatus(['danger', `${e.response.status}: ${e.response.data.message}`]);
    }
    setStateButton("")
  }

  return (
    <form onSubmit={e => handleSubmit(e)}>
        { status!=='' && <Notification color={status[0]}>{status[1]}</Notification> }
        <Controls.CpfCnpjField 
          label="CPF ou CNPJ:"
          name="cpf_cnpj"
          placeholder='123.456.789-01'
          value={values.cpf_cnpj}
          onChange={handleInputChange}
          focus={true}
          required
        />
        <Controls.PasswordField 
          label="Senha:"
          name="password"
          value={values.password}
          onChange={handleInputChange}
          required
        />
        <Controls.ActionButton 
          buttonState={stateButton}
          buttonName='Autenticar'
          color='custom-purple'
          className='is-fullwidth is-medium'
        />
        <Link to="/forgot-password">Esqueci minha senha</Link><br />
        <Link to="/activate">Ativar meu usuário</Link>
    </form>
  )
}

export default LoginForm;
